<app-featuress
    bgImage="dem0.png"
    minHeight = '70vh' >
</app-featuress>
<app-video-showcase-section></app-video-showcase-section>
<app-video-showcase-section></app-video-showcase-section>
<app-video-showcase-section></app-video-showcase-section>
<app-video-showcase-section></app-video-showcase-section>

<app-cards> </app-cards>
<app-money-back-slider> </app-money-back-slider>
